module.exports = __webpack_public_path__ + "img/ascSort.454db491.svg";